import {newSet} from '../actions/library/sets'
import {newQuestion} from '../actions/library/questions'
import {getQuestionBodyLabel} from './getQuestionBodyLabel'


 
export function createCopyOfItem(item) {
	const nowDate = new Date()

	if(item.choices){
		const requestBody = {
			...item,
			'body':`${getQuestionBodyLabel(item)}`,
			'userCreated': nowDate,
			'clientModified':nowDate
		}
		return newQuestion(requestBody)
	}
	else if(item.questions){
		const requestBody = {
			...item,
			'name':`${item.name} Copy`,
			'userCreated': nowDate,
			'clientModified':nowDate
		}
		return newSet(requestBody)

	}

}



  


// WEBPACK FOOTER //
// ./src/utils/createCopyOfItem.js